import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/named
import { getAvatarUrlByMemberId } from '../utilities/url_util';
import { getUserName } from '../utilities/locale_util';
import LightBoxContainer from './LightBoxContainer';
import MenuLink from './menu_link';
import { LazyMemberImg } from './Image';
import { YAHOO_TARGET } from '../constants/yahoo';

const UserBox = props => {
  const [menuLinkData, setMenuLinkData] = useState([]);
  const { target } = useSelector(state => state.init);
  const {
    member: { firstName, lastName, email, _id: memberId, nickname, userid },
    linkData,
    renderRewardPoints,
    // renderLotteriesLink,
    onSignOutClick,
    onCancelClick,
    onUserBoxItemClick
  } = props;
  const userName = getUserName(firstName, lastName);

  useEffect(() => {
    if (target === YAHOO_TARGET) {
      const data = linkData.filter(item => item.isHiddenFromYahoo === false);

      const yahooMenuData = [
        {
          id: 'YAHOO_FUNLIDAY_INDEX_ID',
          isCurrent: false,
          isExternal: false,
          path: '/',
          textId: 'Homepage',
          isHiddenFromYahoo: false
        },
        ...data
      ];
      setMenuLinkData(yahooMenuData);
    } else {
      const data = linkData.filter(item => item.isHiddenFromUserBox === false);
      setMenuLinkData(data);
    }
  }, [linkData]);

  return (
    <LightBoxContainer onClick={onCancelClick}>
      <div className="user-box">
        <div className="user-profile">
          <Link className="user-wrap" to={{ pathname: `/${userid}` }}>
            <div className="user-avatar">
              <LazyMemberImg
                src={getAvatarUrlByMemberId(memberId)}
                alt={nickname || userName}
                title={nickname || userName}
              />
            </div>
            <div className="user-info">
              <span className="user-name">{nickname || userName}</span>
              <span className="user-email">{email}</span>
            </div>
          </Link>
        </div>
        <hr />
        <div className="user-header-link">
          {menuLinkData.map(item => (
            <MenuLink
              id={item.id}
              key={item.id}
              isCurrent={item.isCurrent}
              isExternal={item.isExternal}
              isSsr={item.isSsr}
              path={item.path}
              textId={item.textId}
              className={item.className}
              onClick={onUserBoxItemClick}
            />
          ))}
        </div>
        <hr />

        <div className="user-header-link">
          <MenuLink
            id="PROFILE_ID"
            key="PROFILE_ID"
            isCurrent={false}
            isExternal={false}
            path={`/${userid}`}
            textId="Profile"
            onClick={onUserBoxItemClick}
          />
          {renderRewardPoints()}
          <MenuLink
            id="SETTINGS_ID"
            key="SETTINGS_ID"
            isCurrent={false}
            isExternal={false}
            path="/me/settings"
            textId="Settings"
            onClick={onUserBoxItemClick}
          />
          {/* {renderLotteriesLink()} */}
          <div
            role="button"
            tabIndex={0}
            onClick={onSignOutClick}
            onKeyDown={onSignOutClick}
            className="user-sign-out"
          >
            <FormattedMessage id="Sign out" description="Sign out" />
          </div>
        </div>
      </div>
    </LightBoxContainer>
  );
};

UserBox.defaultProps = {
  member: null,
  onSignOutClick: null,
  onCancelClick: null,
  linkData: [],
  onUserBoxItemClick: null,
  renderRewardPoints: null
  // renderLotteriesLink: null
};

UserBox.propTypes = {
  member: PropTypes.object,
  onSignOutClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  onUserBoxItemClick: PropTypes.func,
  linkData: PropTypes.array,
  renderRewardPoints: PropTypes.func
  // renderLotteriesLink: PropTypes.func
};

export default UserBox;
